module.exports = __webpack_public_path__ + "img/1x2.fbd599a7.png";